import { SendPushNotificationWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('SendPushNotification')
export class SendPushNotificationConnectorProvider extends ConnectorProvider<SendPushNotificationWorkflowNode> {}
